<template>
<div>
    <b-card title="ESTUDIANTE">
        <div>
            <b-form-group label-for="" label="Tipo de documento">
                <b-form-select @change="addThing($event)" :options="type_documents" v-model="type_document"></b-form-select>
            </b-form-group>
            <b-form-group label="No.identificacion">
                <b-input-group>
                    <b-input-group-prepend>
                        <b-input-group-text><i class="fa fa-chevron-right"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"></b-form-input>
                </b-input-group>
            </b-form-group>
            <b-form-group label="Nombre">
                <b-input-group>
                    <b-input-group-prepend>
                        <b-input-group-text><i class="fa fa-chevron-right"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text" v-model="name"></b-form-input>
                </b-input-group>
            </b-form-group>
            <b-form-group label="Fecha nacimiento">
                <b-input-group>
                    <b-input-group-prepend>
                        <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="date" v-model="birthday"></b-form-input>
                </b-input-group>
            </b-form-group>
            <b-form-group label="Direccion">
                <b-input-group>
                    <b-input-group-prepend>
                        <b-input-group-text><i class="fa fa-chevron-right"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text" v-model="address"></b-form-input>
                </b-input-group>
            </b-form-group>
            <b-form-group label="Telefono">
                <b-input-group>
                    <b-input-group-prepend>
                        <b-input-group-text><i class="fa fa-hashtag"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="tel" v-model="phone"></b-form-input>
                </b-input-group>
            </b-form-group>
            <b-form-group label="Celular">
                <b-input-group>
                    <b-input-group-prepend>
                        <b-input-group-text><i class="fa fa-hashtag"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="tel" v-model="cellphone"></b-form-input>
                </b-input-group>
            </b-form-group>
            <b-row class="text-center">
                <b-col>
                    <div>
                        <b-form-group label="Producto">
                            <b-btn v-if="!products.name" variant="success" @click="getProducts">Seleccionar Curso</b-btn>
                            <h3>
                                <b-badge href="#" variant="primary" @click="getProducts">{{products.name}}</b-badge>
                            </h3>
                        </b-form-group>
                    </div>
                </b-col>
                <b-col>
                    <div>
                        <b-form-group label="Curso">
                            <b-btn v-if="!course.name" variant="success" @click="getAllCourses">Seleccionar Curso</b-btn>
                            <h3>
                                <b-badge href="#" variant="primary" @click="getAllCourses">{{course.name}}</b-badge>
                            </h3>
                        </b-form-group>
                    </div>
                </b-col>
                <b-col>
                    <div>
                        <b-form-group label="Acudiente">
                            <b-btn v-if="!attendant.name" variant="success" @click="getAttendants">Seleccionar Acudiente</b-btn>
                            <h3>
                                <b-badge href="#" variant="primary" @click="getAttendants">{{attendant.name}}</b-badge>
                            </h3>
                        </b-form-group>
                    </div>
                </b-col>
            </b-row>
            <b-btn variant="info">Guardar</b-btn>
        </div>
    </b-card>
    <b-modal ref="modalCourse" size="lg" id="modal-course" centered title="Cursos creados">
        <b-container>
            <b-row class="mb-1 text-center">
                <b-col cols="3">
                    <b-form-input v-model="filter_courses" placeholder="Buscar curso" />
                </b-col>
                <b-col>
                    <b-table show-empty :small="true" :fixed="true" :striped="true" :bordered="true" :current-page="currentPage" :items="options" :fields="fields" :filter="filter_courses" :per-page="perPage" @filtered="onFiltered_courses">
                        <template slot="actions" slot-scope="row">
                            <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                            <b-button size="sm" variant="success" @click.stop="selectCourse(row.item, row.index, $event.target)" class="mr-1">
                                Seleccionar
                            </b-button>
                        </template>
                    </b-table>
                    <b-pagination :total-rows="totalRows_courses" :per-page="perPage" v-model="currentPage" class="my-0" />
                </b-col>
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modalAttendant" size="lg" id="modal-attendant" centered title="Acudientes">
        <b-container>
            <b-row class="mb-1 text-center">
                <b-col cols="3">
                    <b-form-input v-model="filter_attendant" placeholder="Buscar Acudiente" />
                </b-col>
                <b-col>
                    <b-table show-empty :small="true" :fixed="true" :striped="true" :bordered="true" :current-page="currentPage" :items="attendant" :fields="fields_attendant" :filter="filter_attendant" :per-page="perPage" @filtered="onFiltered_attendant">
                        <template slot="actions" slot-scope="row">
                            <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                            <b-button size="sm" variant="success" @click.stop="selectAttendant(row.item, row.index, $event.target)" class="mr-1">
                                Seleccionar
                            </b-button>
                        </template>
                    </b-table>
                    <b-pagination :total-rows="totalRows_attendant" :per-page="perPage" v-model="currentPage" class="my-0" />
                </b-col>
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modalProducts" size="lg" id="modal-products" centered title="Productos">
        <b-container>
            <b-row class="mb-1 text-center">
                <b-col cols="3">
                    <b-form-input v-model="filter_products" placeholder="Buscar curso" />
                </b-col>
                <b-col>
                    <b-table show-empty :small="true" :fixed="true" :striped="true" :bordered="true" :current-page="currentPage" :items="products" :fields="fields" :filter="filter_products" :per-page="perPage" @filtered="onFiltered_courses">
                        <template slot="actions" slot-scope="row">
                            <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                            <b-button size="sm" variant="success" @click.stop="selectProducts(row.item, row.index, $event.target)" class="mr-1">
                                Seleccionar
                            </b-button>
                        </template>
                    </b-table>
                    <b-pagination :total-rows="totalRows_attendant" :per-page="perPage" v-model="currentPage" class="my-0" />
                </b-col>
            </b-row>
        </b-container>
    </b-modal>
    
</div>
</template>

<script>
const type_documents = [
  { value: null, text: "Seleccione documentos" },
  { value: 1, text: "Cedula de ciudadania" },
  { value: 2, text: "NIT" },
  { value: 3, text: "Pasaporte" }
];
const fields = [
  {
    key: "name",
    label: "Nombre"
  },
  {
    key: "actions",
    label: "Accion"
  }
];
const fields_attendant = [
  {
    key: "name",
    label: "Nombre"
  },
  {
    key: "document",
    label: "Documento"
  },
  {
    key: "actions",
    label: "Accion"
  }
];
export default {
  name: "create",
  data() {
    return {
      fields: fields,
      fields_attendant: fields_attendant,
      type_documents: type_documents,
      options: [],
      course: {},
      attendant: {},
      products: {},
      filter_courses: "",
      filter_attendant: "",
      filter_products: "",
      currentPage: 1,
      perPage: 5,
      totalRows_courses: 0,
      totalRows_attendant: 0,
      totalRows_products: 0,
      type_document: null,
      name: "",
      birthday: "",
      address: "",
      phone: "",
      cellphone: ""
    };
  },
  mounted() {
    //this.getAllCourses();
  },
  methods: {
    getAllCourses() {
      let self = this;
      this.$store
        .dispatch("academicCoursesAll")
        .then(response => {
          self.options = this.$store.getters.academicCourse.items;
          self.totalRows_courses = self.options.length;
          this.$refs.modalCourse.show();
        })
        .catch(error => {
          this.$root.showInfoDialog(
            "Mensaje informativo",
            "Ocurrio un error, intente nuevamente",
            "Aceptar"
          );
        });
    },
    getAttendants() {
      let self = this;
      this.$store
        .dispatch("academicAttendantAll")
        .then(response => {
          self.attendant = this.$store.getters.academicAttendant.items;
          self.totalRows_attendant = self.options.length;
          this.$refs.modalAttendant.show();
        })
        .catch(error => {
          this.$root.showInfoDialog(
            "Mensaje informativo",
            "Ocurrio un error, intente nuevamente " + error,
            "Aceptar"
          );
        });
    },
    getProducts() {
      if (!this.birthday) {
          this.$root.showInfoDialog("Mensaje Informativo","La fecha de nacimiento debe ser ingresada para poder ver esta seccion.","Aceptar")
        return;
      }
      let data = {
        birthday: this.birthday
      };
      let self = this;
      this.$store
        .dispatch("academicStudentProduct", data)
        .then(response => {
          self.products = this.$store.getters.academicStudents;
          self.totalRows_products = self.options.length;
          console.log("aaa", this.$store.getters.academicStudents);
          this.$refs.modalProducts.show();
        })
        .catch(error => {
          this.$root.showInfoDialog(
            "Mensaje informativo",
            "Ocurrio un error, intente nuevamente " + error,
            "Aceptar"
          );
        });
    },
    selectCourse(item, key) {
      this.$refs.modalCourse.hide();
      this.course = item;
    },
    selectAttendant(item, key) {
      this.$refs.modalAttendant.hide();
      this.attendant = item;
    },
    selectProducts(item, key) {
      this.$refs.modalProducts.hide();
      this.products = item;
    },
    onFiltered_courses(filteredItems) {
      this.totalRows_courses = filteredItems.length;
      this.currentPage = 1;
    },
    onFiltered_attendant(filteredItems) {
      this.totalRows_courses = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/academic/attendant/create.vue